import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../graphql";
import PropTypes from "prop-types";
import { Spin, Row, Col, Button, Form, Modal } from "antd";
import Container from "../../../../components/user/Container";
import ModalConfirmForm from "../../../../components/user/ModalConfirmForm";
import SecProfileInformation from "../sector/SecProfileInfomation";
import SecDocumentInformation from "../sector/SecDocumentInformation";
import SecAttachment from "../sector/SecAttachment";
import SecApproverHistory from "../sector/SecApproverHistory";
import { checkStatusForm } from "../../../../utils/abstainTime";
import { UrlAbstainTime, getToken } from "../../../../utils/auth";
import { apiKeyNews } from "../../../../utils/apiKey";
import axios from "axios";
import moment from "moment";
import { transformToFormData } from "../../../../utils/formData";
import { Link } from "react-router-dom";
import { alertMessage } from '../../../../utils/message';

class FormLeaveCancel extends Component {
  state = {
    dataAbstain: null,
    preLoadOnsubmit: false,
    dataTalbeUploads: [],
    loadingFullpage: true,
    isEdit: true,
    dropdownListApprover: [],
    dataEmployeeOrg: [],
    approverId: null,
    approveStatus: null
  };

  showModalFormConfirm = async (values, messageShow, title, textBtnOK, ModalFormTextArea, ModalFormTextAreaRequie) => {
    const { form, client } = this.props;

    await this.setState({
      ModalConfirmFormTitle: messageShow,
      ModalConfirmFormSubTitle: title,
      ModalConfirmFormShowModal: true,
      ModalConfirmFormBtnOk: textBtnOK,
      ModalConfirmFormBtnCancel: "ยกเลิก",
      ModalConfirmFormValue: values,
      ModalFormTextArea,
      ModalFormTextAreaRequie
    });
  };

  hideModalConfirm = async () => {
    await this.setState({
      ModalConfirmFormTitle: null,
      ModalConfirmFormSubTitle: null,
      ModalConfirmFormShowModal: false,
      ModalConfirmFormBtnOk: null,
      ModalConfirmFormBtnCancel: null,
      ModalConfirmFormValue: null,
    });
  };

  handleSubmit = async (e, statusSend) => {
    const { form } = this.props;
    const { dataAbstain, dataProfile, dataEmployeeOrg, approverId } = this.state;
    const { match, location } = this.props;

    e.preventDefault();

    form.validateFields(async (err, values) => {
      if (err) {
        Modal.error({
          className: "modalFickIcons",
          title:
            statusSend == "reject"
              ? "ไม่อนุมัติแก้ไขการลงเวลาทำงานไม่สำเร็จ"
              : "อนุมัติแก้ไขการลงเวลาทำงานไม่สำเร็จ",
          width: "600px",
          content: <h3 className="mt-3">กรุณาระบุข้อมูลให้ครบถ้วน</h3>,
          okText: "ปิด",
          onOk() {},
        });
      } else {
         let valuesToSend = {};
         valuesToSend.abTimeHdId = dataAbstain.abTimeHdId;
         valuesToSend.approveAction = statusSend;
         valuesToSend.approverId = approverId;
         valuesToSend.description = "test";

         let ModalFormTextArea = true;
         let ModalFormTextAreaRequie = false;
        console.log('valuxxxxes', values)

        let abTimeDtList = []

        if (values.tbAbstainTimeDt){
          values.tbAbstainTimeDt.map((valueReturn, keys) => {
            if (valueReturn.isApprove) {
              valueReturn.isApprove = 1
              valueReturn.abTimeDTid = valueReturn.abTimeDtId
              delete valueReturn.isValidate;
                delete valueReturn.disabledRow;
                delete valueReturn.isShowEditButton;
                delete valueReturn.isShowSaveButton;
                delete valueReturn.listNo;
                delete valueReturn.abTimeHdId;
                delete valueReturn.abTimeDtId;
                abTimeDtList.push(valueReturn);
            } 
          });
          console.log("abTimeDtList",abTimeDtList)
          valuesToSend.abTimeDtList = abTimeDtList
        }
        



        console.log('valuxxxxes valuesToSend', valuesToSend)
        if(statusSend == "reject"){
            ModalFormTextAreaRequie = true
        }

        let titleModal = statusSend == 'reject' ? 'ท่านต้องการไม่อนุมัติรายการแก้ไขการลงเวลาทำงาน?'  : 'ท่านต้องการอนุมัติรายการแก้ไขการลงเวลาทำงาน?';
          await this.showModalFormConfirm(
            valuesToSend,
            titleModal,
            "",
            "ตกลง",
            ModalFormTextArea,
            ModalFormTextAreaRequie
          );
      }
    });
  };

  sendToApproves = async (values) => {
    const {} = this.props;
    const { dataAbstain, dataProfile, dataEmployeeOrg } = this.state;


    values.description = values.ModalNoteApprove
    delete values.ModalNoteApprove

    const formData = new FormData();
    formData.append('tbAbstainTimeHd', JSON.stringify(values))

    const { token } = getToken();
    const { match } = this.props;
    const API_DEVICE_KEY = atob(apiKeyNews());

    await this.setState({
      loadingFullpage: true,
    });

    const headers = {
      //"Content-Type": 'multipart/form-data',
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .post(
        `${UrlAbstainTime()}/approveAbstainTime`,
         values
        ,
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        console.log("response", response);
        let messageShow = values.approveAction == 'reject' ? 'ไม่อนุมัติรายการแก้ไขการลงเวลาทำงานที่เลือกเรียบร้อย'  : 'ทำการอนุมัติรายการแก้ไขการลงเวลาทำงานที่เลือกเรียบร้อย';
        alertMessage("success", messageShow)
        setTimeout(() => {
         window.location.href = '/AbstainTime/Confirm'
         }, 2000);
      })
      .catch((error) => console.error(`Error: ${error}`));

    await this.hideModalConfirm();
  };

  fetchAbstainTimeForApproveById = async () => {
      const { token } = getToken();
      const { approverId, dataProfile } = this.state
      const { match, location } = this.props;
      const API_DEVICE_KEY = atob(apiKeyNews());

      await this.setState({
      loadingFullpage: true,
      });

      const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
      };

      // console.log('location.state.approverId', `${UrlAbstainTime()}/fetchAbstainTimeForApproveById?approverId=${approverId}`)
      axios
      .get(
         `${UrlAbstainTime()}/fetchAbstainTimeForApproveById?approverId=${approverId}`,
         {
            headers: headers,
         }
      )
      .then(async (response) => {
         console.log('12312312312', response)
         console.log('12312312312', dataProfile.employeeCodes[0])
         const statusApproves = response.data.data.tbApprover.find(detail => detail.approverId == approverId)
         
         await this.setState({
            dataAbstain: response.data.data,
            loadingFullpage: false,
            isEdit: false,
            approveStatus: statusApproves.status
         });
      })
      .catch((error) => console.error(`Error: ${error}`));
   };

  fetchDropDownMasterData = async (dropDownType) => {
    const { client, location, match } = this.props;
    const { empCode } = this.state;

    let dropDownRetrue = [];
    try {
      const { data, errors } = await client.query({
        query: Queries.fetchDropDownMasterData,
        variables: {
          dropDownType,
        },
      });

      await data.fetchDropDownMasterData.map((values, keys) => {
        dropDownRetrue.push({
          value: values.id,
          label: values.label,
        });
      });

      await this.setState({
        ["dropDownType" + dropDownType]: dropDownRetrue,
      });
      // return dropDownRetrue;
    } catch (error) {
      console.log(error);
      return dropDownRetrue;
    }
  };

   getAbstainTimeForApproverList = async (empCode) => {
      const { token } = getToken()
      const { client, location, match } = this.props;
      const { approverId } = this.state;

      await this.setState({
         loading: true,
      });

      const API_DEVICE_KEY = atob(apiKeyNews())

      const headers = {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`,
         'apiKey': API_DEVICE_KEY
      }

      axios.get(`${UrlAbstainTime()}/getAbstainTimeForApproverList`,
      {
         params: {
            empCode,
            searchKeyWord: approverId,
            // status: "pending",
         },
         headers: headers
      })
      .then(async (response) => {
         console.log('response.data.data[0]', response.data.data[0])
         let dataTalbeArray = []
         if(response.data.data){
            await this.setState({
               approveStatus: response.data.data[0].status
            })
         }
      }).catch(
         error => console.error(`Error: ${error}`)
      )
   };

  fetchListProfile = async () => {
    const { client } = this.props;
    try {
      const { date } = this.state;
      const { data, errors } = await client.query({
        query: Queries.fetchProfile,
      });

      if (data.fetchProfile) {
        console.log("data.fetchProfile", data.fetchProfile);
        await this.setState({
          dataProfile: data.fetchProfile,
        });
        await this.fetchEmployeeDetail();
      //   await this.getAbstainTimeForApproverList(data.fetchProfile.employeeCodes[0])
      } else {
        await this.setState({
          dataProfile: null,
        });
      }
    } catch (error) {
      await this.setState({
        dataProfile: null,
      });
    }
  };

  fetchEmployeeDetail = async () => {
    const { client, location, match } = this.props;
    const { dataProfile } = this.state;
    const { data, errors } = await client.query({
      query: Queries.fetchEmployeeDetail,
      variables: {
        empCode: dataProfile.employeeCodes[0],
      },
    });

    if (data.fetchEmployeeDetail) {
      await this.setState({
        orgCode: data.fetchEmployeeDetail.orgCode,
      });
      console.log(
        "data.fetchEmployeeDetail.orgCode",
        data.fetchEmployeeDetail.orgCode
      );
      await this.fetchEmpStudyLeaveRequestByOrgCode();
    } else {
      await this.setState({
        detailProfile: null,
      });
    }
  };

  fetchEmpStudyLeaveRequestByOrgCode = async (params = {}, token) => {
    // let url = `${HostAPIMock}/fetchAbstainTimeById?abTimeHdId=${"773c220b-7c61-47dd-a7bd-ea84b5114807"}`
    let url = `https://6392a561b750c8d178e26ea1.mockapi.io/api/fetchEmpStudyLeaveRequestByOrgCode?empCode=${"65000002"}&orgCode=${"22"}`;
    return await axios
      .get(
        url
        // {
        //     Authorization: Bearer ${token}
        // }
      )
      .then((response) => {
        const data = { ...response.data[0] };
        console.log("data employee by org api", data);
        this.setState({
          dataEmployeeOrg: data,
        });
        // console.log("response",response);
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  getAbstainApproverList = async () => {
    const { token } = getToken();
    const { dataProfile, orgCode } = this.state;

    console.log("getAbstainApproverList empcode", dataProfile.employeeCodes[0]);
    console.log("getAbstainApproverList orgCode", orgCode);

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .get(
        `${UrlAbstainTime()}/getAbstainApproverList?empCode=${
          dataProfile.employeeCodes[0]
        }&orgCode=${orgCode}`,
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        console.log("response.data", response.data.data);
        await this.setState({
          dropdownListApprover: response.data.data,
          loading: false,
        });
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  checkShowBtnSubmit = () => {
    const { dataAbstain } = this.state;
    if (dataAbstain.status == "approve") {
      return true;
    } else if (dataAbstain.status == "draft") {
      return false;
    } else if (dataAbstain.status == "pending") {
      return true;
    } else {
      return false;
    }
  };

  async componentDidMount() {
    const { match, location } = this.props;
    const { dataAbstain } = this.state;

    await this.setState({
      approverId: location.state ? location.state.approverId : match.url.split('/')[3]
   })

    await this.fetchListProfile();
    await this.fetchDropDownMasterData("abstainTimeDocType");
    await this.fetchAbstainTimeForApproveById();
  }

  render() {
    const { match, location } = this.props;
    const {
      detailForm,
      preLoadOnsubmit,
      ModalConfirmFormTitle,
      ModalConfirmFormSubTitle,
      ModalConfirmFormShowModal,
      ModalConfirmFormBtnOk,
      ModalConfirmFormBtnCancel,
      ModalConfirmFormValue,
      loadingFullpage,
      loginPerson,
      dataAbstain,
      isEdit,
      dropdownListApprover,
      dataEmployeeOrg,
      ModalFormTextArea,
      ModalFormTextAreaRequie,
      approveStatus
    } = this.state;

    console.log('dxataAbstain', dataAbstain)
   //  console.log("dxataabstain", location.state.statusForm);
   console.log('approveStatus main', approveStatus)

    return (
      <Container match={match}>
        <div className="breadcrumb-custom pb-3 mb-5">
          <span style={{ fontSize: "18px" }}>การแก้ไขการลงเวลาทำงาน / อนุมัติเอกสารแก้ไขการลงเวลาทำงาน </span>
        </div>
        <ModalConfirmForm
          title={ModalConfirmFormTitle}
          subtitle={ModalConfirmFormSubTitle}
          showModal={ModalConfirmFormShowModal}
          btnOk={ModalConfirmFormBtnOk}
          btnCancel={ModalConfirmFormBtnCancel}
          submitToSend={this.sendToApproves}
          hideModal={this.hideModalConfirm}
          valueConfirm={ModalConfirmFormValue}
          ModalFormTextArea = { ModalFormTextArea }
          ModalFormTextAreaRequie = {ModalFormTextAreaRequie}
        />
         <Spin spinning={loadingFullpage} delay={500}>
            {/* {console.log("dataAbstain", dataAbstain)} */}
            <div className="card-container h-100" id="page-profile">
            {
               dataAbstain && 
               <Form ref={this.formRef}>
               <div className="px-5 pt-1 pb-4 card-bg-green">
                 <SecProfileInformation
                   loginProfile={loginPerson}
                   propFormInput={this.props.form}
                   rawData={
                     dataAbstain ? dataAbstain : dataEmployeeOrg
                   }
                   isViewOnly={!isEdit}
                 />

                 <SecDocumentInformation
                   loginProfile={loginPerson}
                   propFormInput={this.props.form}
                   rawData={dataAbstain}
                   isViewOnly={!isEdit}
                   form={this.formRef}
                   viewModeApproves={true}
                   approveStatus={approveStatus}
                 />
                 
                 <SecAttachment
                        loginProfile={loginPerson}
                        propFormInput={this.props.form}
                        rawData={dataAbstain ? dataAbstain.tbAttachFile : []}
                        isViewOnly={!isEdit}
                        form={this.formRef}
                        dropDownTypeDoc={
                          this.state.dropDownTypeabstainTimeDocType
                            ? this.state.dropDownTypeabstainTimeDocType
                            : []
                        }
                      />

                 <SecApproverHistory
                   loginProfile={loginPerson}
                   propFormInput={this.props.form}
                   rawDataApprover={dataAbstain ? dataAbstain.tbApprover : []}
                   rawDataHistory={
                     dataAbstain ? dataAbstain.tbAbstainTimeHistory : []
                   }
                   isViewOnly={!isEdit}
                   form={this.formRef}
                   dropdownListApprover={dropdownListApprover}
                   status={
                     dataAbstain
                       ? dataAbstain.approveStatus
                       : "create"
                   }
                 />
                 <Row
                   gutter={16}
                   type="flex"
                   justify="left"
                   align="top"
                   className=""
                 >
                   <Col xs={24} md={24} className="pt-2" align="center">
                       <Link
                          to={{
                             pathname: '/AbstainTime/Confirm',
                          }}
                          >
                          <Button
                             type="primary"
                             className="mx-2 btn-white-red"
                             disabled={preLoadOnsubmit}
                          >
                             ย้อนกลับ
                          </Button>
                       </Link>
                       {
                          approveStatus == "pending" &&
                              <>
                                 <Button
                                    type="primary"
                                    className="mx-2 btn-white-red"
                                    htmlType="submit"
                                    onClick={(e) => {
                                    this.handleSubmit(e, "reject");
                                    }}
                                    disabled={preLoadOnsubmit}
                                 >
                                    ไม่อนุมัติ
                                 </Button>
                                 <Button
                                    type="primary"
                                    className="ml-2 color-white"
                                    htmlType="submit"
                                    disabled={preLoadOnsubmit}
                                    onClick={(e) => {
                                    this.handleSubmit(e, "approve");
                                    }}
                                 >
                                    อนุมัติ
                                 </Button>
                              </>
                       }
                       
                   </Col>
                 </Row>
               </div>
             </Form>
            }
              
            </div>
         </Spin>
      </Container>
    );
  }
}

FormLeaveCancel.defaultProps = {
  autoFocus: false,
};

FormLeaveCancel.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedFormLeaveCancel = Form.create()(FormLeaveCancel);

export default withApollo(WrappedFormLeaveCancel);
